<div class="card-container">
  @for (card of cards; track card) {
    @if (card) {
      <div class="card" (click)="onClickCard.emit(card)">
        <span
          #cardElement
          (mouseenter)="updateTooltip(cardElement)"
          [tooltipDisabled]="tooltipDisabled()"
          [pTooltip]="card"
          tooltipPosition="bottom"
          tooltipStyleClass="u-tooltip"
          >{{ card }}</span
        >
      </div>
    }
  }
</div>
